import React from 'react';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { ArrowLeft, Video, Film, GraduationCap } from 'lucide-react';
export function FilmsPage() {
  return <div className="min-h-screen font-sans" style={{
    backgroundColor: '#0D121D'
  }} data-id="element-296">
      <Header data-id="element-297" />

      <main className="pt-32 pb-24 min-h-screen" data-id="element-298">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-299">
          <a href="/" className="inline-flex items-center text-slate-300 hover:text-white transition-colors mb-12" data-id="element-300">
            <ArrowLeft className="w-5 h-5 mr-2" data-id="element-301" />
            Back to Home
          </a>

          <div className="text-center max-w-4xl mx-auto mb-16" data-id="element-302">
            <div className="mb-12 flex justify-center" data-id="element-303">
              <img src="https://cdn.magicpatterns.com/uploads/5psnYgvbA4E9mU4Q3CmWZP/Twice_Bourne_Ent._Logo_White-08.png" alt="Twice Bourne Entertainment Films Logo" className="max-w-md w-full h-auto" data-id="element-304" />
            </div>

            <h1 className="text-4xl md:text-5xl font-bold text-white mb-6" data-id="element-305">
              Twice Bourne Entertainment Films LLC
            </h1>
            <p className="text-xl text-slate-300" data-id="element-306">
              Crafting compelling narratives that captivate audiences globally.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-307">
            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-308">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-309">
                <Video className="w-8 h-8" data-id="element-310" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-311">
                Film Production
              </h3>
              <p className="text-slate-300" data-id="element-312">
                Producers and sellers of high-quality movies, dedicated to
                cinematic storytelling.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-313">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-314">
                <Film className="w-8 h-8" data-id="element-315" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-316">
                Film Acquisition
              </h3>
              <p className="text-slate-300" data-id="element-317">
                Buying movies from independent producers to expand our diverse
                portfolio.
              </p>
            </div>

            <div className="bg-white/5 backdrop-blur rounded-2xl border border-slate-700/50 hover:border-slate-500 transition-colors p-8 flex flex-col items-center text-center" data-id="element-318">
              <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center mb-6 text-white" data-id="element-319">
                <GraduationCap className="w-8 h-8" data-id="element-320" />
              </div>
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-321">
                Cinematic Courses
              </h3>
              <p className="text-slate-300" data-id="element-322">
                Hosting of mini courses for cinematic enthusiasts to learn the
                art of filmmaking.
              </p>
            </div>
          </div>
        </div>
      </main>

      <Footer data-id="element-323" />
    </div>;
}